import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { environment } from "@environments/environment";

@Injectable({
    providedIn: "root",
})
export class ApiService {
    private readonly baseUrl = environment.backendBaseUrl;

    constructor(private readonly http: HttpClient) {}

    get<T>(path: string, params?: Record<string, string | number | boolean>): Observable<T> {        
        const httpParams = params ? new HttpParams({ fromObject: params as Record<string, string> }) : undefined;
        return this.http.get<T>(this.buildUrl(path), { params: httpParams }).pipe(catchError(this.handleError));
    }

    post<T>(path: string, body: unknown): Observable<T> {
        return this.http.post<T>(this.buildUrl(path), body).pipe(catchError(this.handleError));
    }

    patch<T>(path: string, body: unknown): Observable<T> {
        return this.http.patch<T>(this.buildUrl(path), body).pipe(catchError(this.handleError));
    }

    put<T>(path: string, body: unknown): Observable<T> {
        return this.http.put<T>(this.buildUrl(path), body).pipe(catchError(this.handleError));
    }

    delete<T>(path: string): Observable<T> {
        return this.http.delete<T>(this.buildUrl(path)).pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse): Observable<never> {
        return throwError(() => error);
    }

    private buildUrl(path: string): string {
        const normalizedBaseUrl = this.baseUrl.endsWith("/") ? this.baseUrl : `${this.baseUrl}/`;
        const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
        return `${normalizedBaseUrl}${normalizedPath}`;
    }
}